import React from 'react';
import { TabContainer, Tab, TabItem, TabItemWrapper } from './css';
import { managedDetectionResponse } from '../../utils/constant';


const TabSelection = ({ selectedTab, setSelectedTab }) => {
  return (
    <TabContainer>
      <Tab>
        <TabItemWrapper active={selectedTab === 'MANAGED_IT_SERVICE'}>
          <TabItem
            active={selectedTab === 'MANAGED_IT_SERVICE'}
            onClick={() => setSelectedTab('MANAGED_IT_SERVICE')}
          >
            Managed IT Services
          </TabItem>
        </TabItemWrapper>
        <TabItemWrapper active={selectedTab === 'MICROSOFT_LICENSING'}>
          <TabItem
            active={selectedTab === 'MICROSOFT_LICENSING'}
            onClick={() => setSelectedTab('MICROSOFT_LICENSING')}
          >
            Microsoft Licensing
          </TabItem>
        </TabItemWrapper>
          <TabItemWrapper active={selectedTab === 'MANAGED_DETECTION_RESPONSE'}>
            <TabItem
              active={selectedTab === 'MANAGED_DETECTION_RESPONSE'}
              onClick={() => setSelectedTab('MANAGED_DETECTION_RESPONSE')}
            >
              {managedDetectionResponse}
            </TabItem>
          </TabItemWrapper>
      </Tab>
    </TabContainer>
  );
};

export default TabSelection;
